// This utils help to make clear assertions about expected values
export const assertTrue = (value: boolean, message?: string, getError?: (msg: string) => Error) => {
    if(typeof value !== 'boolean')
        throw new TypeError('value parameter has to be boolean');
    if(getError && typeof getError !== 'function')
        throw new TypeError('getError parameter has to be a function');

    if(!value) {
        throw (getError ? getError(message) : new Error(message));
    }
}

export const hasValue = (value: any): boolean => value !== null && value !== undefined;
export const hasNoValue = (value: any): boolean => !hasValue(value);
export const assertValue = <T>(value: T, message?: string): T => {
    assertTrue(hasValue(value), message);
    return value;
}

export const assertBoolean = (value: any, message?: string): boolean => {
    assertTrue(typeof value === 'boolean', message, TypeError);
    return value as boolean;
}

export const isNumber = (value: any): boolean => typeof value === 'number';
export const assertNumber = (value: any, message?: string): number => {
    assertTrue(isNumber(value), message, TypeError);
    return value as number;
};

export const isString = (value: any): boolean => typeof value === 'string';
export const assertString = (value: any, message?: string): string => {
    assertTrue(isString(value), message, TypeError);
    return value as string;
}

export const assertArray = <T>(value: T[], message?: string): T[] => {
    assertTrue(Array.isArray(value), message, TypeError);
    return value;
}
export const assertError = (value: any, message?: string) => assertTrue(value instanceof Error, message, TypeError);


// WEBPACK FOOTER //
// ./src/app/utils/assert/index.ts